import request from '@/utils/request'

export function fetchSalesChannelList (query) {
  return request({
    url: '/card/api/card_group_sales_channel/index',
    method: 'get',
    params: query
  })
}

export function createSalesChannel (data) {
  return request({
    url: '/card/api/card_group_sales_channel/insert',
    method: 'post',
    data
  })
}

export function updateSalesChannel (id, data) {
  return request({
    url: '/card/api/card_group_sales_channel/update',
    method: 'post',
    params: { id },
    data
  })
}

export function catelog (id, catelogId) {
  return request({
    url: '/card/api/card_group_sales_channel/catelog',
    method: 'post',
    data: {id, catelogId}
  })
}



// WEBPACK FOOTER //
// ./src/card/api/group-sales-channel.js